module.exports = __webpack_public_path__ + "0e5e97b93e365aa7f8c1a3c7cd944341.svg";